import { CheckCircleOutline } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';

import { translate } from '@/ui/i18n';

export function FinishMessage() {
  return (
    <Stack alignItems={'left'} sx={{ my: 2, mx: 8 }}>
      <CheckCircleOutline sx={{ color: '#41D650', fontSize: '7.25rem' }} />
      <Typography sx={{ fontSize: '2.75rem', fontWeight: '900' }}>
        {translate('External.thanks-for-your-response')}
      </Typography>
      <Typography sx={{ fontSize: '1.25rem', fontWeight: '800' }}>
        {translate('External.your-informations-are-saved')}
      </Typography>
    </Stack>
  );
}
